import { axiosInstance } from '@src/services/common';

export interface GetEventNamesRequest {
  time_range: [string, string] | undefined;
  key: string;
}

export interface GetEventNamesResponse {
  event_names: string[];
}

export async function getEventNames(payload: GetEventNamesRequest) {
  const response = await axiosInstance.post<GetEventNamesResponse>(
    '/gm/v1/metadata/event_names',
    payload,
  );

  return response.data.event_names;
}

export interface GetTagKeysRequest {
  event_name?: string;
  time_range: [string, string] | undefined;
  key: string;
}

export interface GetTagKeysResponse {
  tag_keys: string[];
}

export async function getTagKeys(payload: GetTagKeysRequest) {
  const response = await axiosInstance.post<GetTagKeysResponse>(
    '/gm/v1/metadata/tag_keys',
    payload,
  );

  return response.data.tag_keys;
}

export interface GetTagValuesRequest {
  dimension_id?: string;
  event_name?: string;
  time_range: [string, string] | undefined;
  tag_key: string;
  key: string;
}

export interface GetTagValuesResponse {
  tag_values: { label: string; val: string }[];
}

export async function getTagValues(payload: GetTagValuesRequest) {
  const response = await axiosInstance.post<GetTagValuesResponse>(
    `/gm/v1/metadata/tag_values${payload.dimension_id ? `/${payload.dimension_id}` : ''}`,
    payload,
  );

  return response.data.tag_values;
}
